var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3118 6.94384C12.539 6.66793 12.539 6.39203 12.3118 6.11612L9.00094 2.80526C8.72503 2.57804 8.44913 2.57804 8.17322 2.80526C7.94601 3.08116 7.94601 3.35707 8.17322 3.63298L10.486 5.94571H0.602061C0.245008 5.97817 0.0502512 6.17292 0.0177917 6.52998C0.0502512 6.88703 0.245008 7.08179 0.602061 7.11425H10.486L8.17322 9.42698C7.94601 9.70289 7.94601 9.97879 8.17322 10.2547C8.44913 10.4819 8.72503 10.4819 9.00094 10.2547L12.3118 6.94384Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 13.03)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6c537925aa8457b32778b548f3f59184.svg";
export { ForwardRef as ReactComponent };